var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.914 1.214a4.997 4.997 0 00-4.997 4.997v1.933a9.014 9.014 0 01-1.622 5.187l-.004.005-.034.047a.327.327 0 00.253.488h12.932a.328.328 0 00.243-.484 9.014 9.014 0 01-1.774-5.303V6.211a4.997 4.997 0 00-4.997-4.997zM2.31 8.144h-.607V6.212a6.211 6.211 0 1112.423 0v1.866a7.799 7.799 0 001.578 4.648 1.54 1.54 0 01-1.233 2.36H1.488l-.035-.001a1.54 1.54 0 01-1.197-2.388l.045-.063a7.8 7.8 0 001.402-4.486l.607-.002zM6.194 15.994a.607.607 0 01.84.182 1.327 1.327 0 001.193.609 1.326 1.326 0 001.147-.609.607.607 0 111.022.657 2.54 2.54 0 01-2.18 1.166 2.54 2.54 0 01-2.204-1.166.607.607 0 01.182-.84z",
    fill: "#C4C4C4"
  })));
}
export default SvgNotifications;